import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Emoji } from "../PhoneSlide.types";
import styles from "./PhoneLayers.module.scss";

export const VotingButtons = ({ isActive }: { isActive: boolean }) => {
  const [currentVote, setCurrentVote] = useState<"live" | "die" | null>(null);
  const [dieEmojis, setDieEmojis] = useState<Array<Emoji>>([]);
  const [liveEmojis, setLiveEmojis] = useState<Array<Emoji>>([]);

  // Add new emojis to either die or live set
  const addEmoji = (setEmojis: Dispatch<SetStateAction<Array<Emoji>>>) => {
    setEmojis((prev) => {
      const newId = prev.length ? prev[prev.length - 1].id + 1 : 1;
      const randomX = Math.random() * 40 + 35;
      const randomY = Math.random() * 20 + 70;

      const updatedArray = [...prev, { id: newId, x: randomX, y: randomY }];

      setTimeout(() => {
        setEmojis((current) => current.filter((emoji) => emoji.id !== newId));
      }, 2000);

      return updatedArray;
    });
  };

  // Automatically start popping emojis when the component is rendered
  useEffect(() => {
    if (!isActive) {
      setLiveEmojis([]);
      setDieEmojis([]);
      setCurrentVote(null);
      return;
    }

    const liveInterval = setInterval(() => {
      if (currentVote === null || currentVote === "live") {
        addEmoji(setLiveEmojis);
      }
    }, 300);

    const dieInterval = setInterval(() => {
      if (currentVote === null || currentVote === "die") {
        addEmoji(setDieEmojis);
      }
    }, 300);

    return () => {
      clearInterval(liveInterval);
      clearInterval(dieInterval);
    };
  }, [isActive, currentVote]);

  return (
    <div className={styles.screenAnimationWrapper}>
      <div className={styles.buttonContainer}>
        <div className={styles.emojiContainer}>
          {liveEmojis.map(({ id, x, y }) => (
            <span
              key={id}
              className={styles.emoji}
              style={{
                left: `${x}%`,
                top: `${y}%`,
                opacity: currentVote === "live" ? 1 : 0,
              }}
            >
              <img src="/images/emojis/live.png" alt="" />
            </span>
          ))}
        </div>
        <button
          className={`${styles.button}${
            currentVote === "live" ? ` ${styles.liveActive}` : ""
          }`}
          onClick={() => setCurrentVote("live")}
        >
          <img src="/images/live-button.png" alt="Live" />
        </button>
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.emojiContainer}>
          {dieEmojis.map(({ id, x, y }) => (
            <span
              key={id}
              className={styles.emoji}
              style={{
                left: `${x}%`,
                top: `${y}%`,
                opacity: currentVote === "die" ? 1 : 0,
              }}
            >
              <img src="/images/emojis/die.png" alt="" />
            </span>
          ))}
        </div>
        <button
          className={`${styles.button}${
            currentVote === "die" ? ` ${styles.dieActive}` : ""
          }`}
          onClick={() => setCurrentVote("die")}
        >
          <img src="/images/die-button.png" alt="Die" />
        </button>
      </div>
    </div>
  );
};
